// =============================================================================
// R-160 — Source color palette. Stable across all panels.
// =============================================================================

export const SOURCE_COLORS: Record<string, string> = {
  GlyphMatch: "#16a34a",      // forest — confident OCR
  InkDensity: "#ea580c",      // safety orange — the new R-143 path
  LabelDiscovery: "#0284c7",  // cobalt
  Region: "#9333ea",          // violet
  Unresolved: "#dc2626",      // red — operator must hand-key
  Legacy: "#71717a",          // slate — pre-R-143 rows
};

export const SOURCE_ORDER = [
  "GlyphMatch",
  "InkDensity",
  "LabelDiscovery",
  "Region",
  "Unresolved",
  "Legacy",
] as const;
